/**
 * Created with IntelliJ IDEA.
 * User: omerh
 * Date: 6/2/13
 * Time: 4:46 PM
 * To change this template use File | Settings | File Templates.
 */

define(function (require) {
    "use strict";
    var _ = require("underscore");
    var Marionette = require("marionette");
    var CONST = require("const");
    var Media = require("media");
    var NotifierModel = require("ui/notifier/js/models/NotifierModel");
    var Logger = require("logger");
    var HtmlSanitizerUtils = require("HtmlSanitizerUtils");
    var NotifierView = require("ui/notifier/js/views/NotifierView");
    var TemplateInfo = require("ui/notifier/templates/notifier.tmpl");
    var TemplateErrorMini = require("ui/notifier/templates/notifierMiniError.tmpl");
    var TemplateError = require("ui/notifier/templates/notifierErrorWithOverlay.tmpl");
    var TemplateConfirm = require("ui/notifier/templates/notifierConfirmWithOverlay.tmpl");
    var TemplateNoClose = require("ui/notifier/templates/notifierNoClose.tmpl");
    var Translator = require("i18n/translator");

    var Notifier = function (moduleName, container, containerRoot) {
        // save the number of info notifications per module(application), we display only 3 info notification per module and we display the newer notification on the top
        var notifications = {};
        var module = moduleName;
        var notifierContainer = container;
        var rootContainer = containerRoot;
        var vent = Media.vent();
        var DEFAULT_TIME_TO_SHOW = 3000;
        var DEFAULT_NOTIFIER_HEIGHT = 65;
        var DEFAULT_NOTIFIER_TOP = 175;
        var ERROR_MINI_NOTIFIER_TOP = 155;
        var logger = Logger.getLogger("Notifier");

        vent.on(module + ":notifier:onNotificationClosed", function (options) {
            onNotificationClosed(options);
        }, this);

        vent.on(module + ":notifier:onNotificationRender", function (options) {
            onNotificationRender(options);
        }, this);

        var onNotificationRender = function (options) {
            var instanceId = options.id;
            var instanceModule = options.module;
            var instance = _getModuleInstance(instanceModule, instanceId);
            instance.top = options.top;
            instance.height = window.parseInt(options.height, 10);
        };

        var onNotificationClosed = function (options) {
            var instanceId = options.id;
            var instanceModule = options.module;
            _removeModuleInstance(instanceModule, instanceId);
        };
        var getModule = function () {
            return module;
        };
        var _getModuleInstance = function(instanceModule, instanceId){
            return _.find(notifications[instanceModule], {id: instanceId});
        };
        var _removeModuleInstance = function(instanceModule, instanceId){
            if (_.isArray(notifications[instanceModule])){
                if (notifications[instanceModule].length === 1){
                    delete notifications[instanceModule];
                }
                else {
                    var index = _.findIndex(notifications[instanceModule], {id: instanceId});
                    notifications[instanceModule].splice(index, 1);
                }
            }
        };
        var _getLatestModuleInstance = function(instanceModule){
            if (_.isUndefined(notifications[instanceModule])){
                return null;
            }
            return notifications[instanceModule][notifications[instanceModule].length - 1];
        };
        var _createModuleInstance = function(instanceModule, content, requestTop){
            var latestInstance = _getLatestModuleInstance(instanceModule);
            var id = _.isNull(latestInstance) ? 1 : latestInstance.id + 1;
            var top = _.isNull(latestInstance) ? requestTop > 0 ? requestTop : DEFAULT_NOTIFIER_TOP : latestInstance.top + latestInstance.height + 10;
            var newInstance = {id: id, top: top, height: DEFAULT_NOTIFIER_HEIGHT, content: content};
            if (_.isNull(latestInstance)){
                notifications[instanceModule] = [];
            }
            notifications[instanceModule].push(newInstance);
            return newInstance;
        };
        var _isContentDisplayed = function(instanceModule, content){
            var found = _.find(notifications[instanceModule], {content: content});
            return !_.isUndefined(found);
        };
        var show = function (options) {
            var displayNotification = false;
            var title = options.title || "";
            var template;
            var notifierClass;
            var notifierImageClass;
            var topPosition;
            var contentMessageClass;
            var content = options.content;
            var message = _.isString(content) ? content : '';
            var contentView = content && (content instanceof Marionette.View) ? content : null;
            var currentModule = options.module || getModule();
            var container = options.container || notifierContainer;
            var objectAction = options.objectAction || {};
            var callback = objectAction.callback || null;
            var middleCallback = objectAction.middleCallback || null;
            var cancelCallback = objectAction.cancelCallback || null;
            var textAction =            objectAction.text || "";
            var textMiddleButton =      objectAction.textMiddleButton || "";
            var textAdditionalButton =  objectAction.textAdditionalButton || Translator.translate("LEUIComponents.global.cancel");
            var timeToShow = options.timeToShow || DEFAULT_TIME_TO_SHOW;
            var removePrimaryButton   =   options.removePrimaryButton || false;
            var removeMiddleButton    = _.isUndefined(options.removeMiddleButton) ? true : options.removeMiddleButton;
            var removeAditionalButton =   options.removeAditionalButton || false;
            var pageToIgnoreDomEvents = options.pageToIgnoreDomEvents;
            var closeButtonText = Translator.translate("LEUIComponents.global.close");            
            var instances = notifications[currentModule];
            var persist = _.isUndefined(options.persist) ? true : options.persist;

            if (!content || !_.isString(message) && !(contentView instanceof Marionette.View)) {
                throw "notifier options must contain a 'content' property, and it must be of type 'String' or 'Marionette.View'";
            }

            if (options.type === CONST.SYSTEM_NOTIFICATIONS.INFO && (!_.isArray(instances) || (_.isArray(instances) && instances.length < CONST.SYSTEM_NOTIFICATIONS.ALLOW_INFO_NUMBER))) {
                displayNotification = true;
                notifierImageClass = "";
                notifierClass = "notifier";
                template = TemplateInfo;
            } else if (options.type === CONST.SYSTEM_NOTIFICATIONS.WARNING && (!_.isArray(instances) || (_.isArray(instances) && instances.length < CONST.SYSTEM_NOTIFICATIONS.ALLOW_INFO_NUMBER))) {
                displayNotification = true;
                notifierImageClass = "notifierImgWarning";
                notifierClass = "notifier";
                template = TemplateInfo;
            } else if (options.type === CONST.SYSTEM_NOTIFICATIONS.SUCCESS && (!_.isArray(instances) || (_.isArray(instances) && instances.length < CONST.SYSTEM_NOTIFICATIONS.ALLOW_NUMBER_PER_APPLICATION))) {
                displayNotification = true;
                notifierImageClass = "notifierSuccess";
                notifierClass = "notifier";
                template = TemplateInfo;
            } else if (options.type === CONST.SYSTEM_NOTIFICATIONS.ERROR && (!_.isArray(instances) || (_.isArray(instances) && instances.length < CONST.SYSTEM_NOTIFICATIONS.ALLOW_NUMBER_PER_APPLICATION))) {
                displayNotification = true;
                notifierImageClass = "notifierImgError";
                notifierClass = "notifier";
                template = TemplateInfo;
            } else if (options.type === CONST.SYSTEM_NOTIFICATIONS.ERROR_MINI && (!_.isArray(instances) || (_.isArray(instances) && instances.length < CONST.SYSTEM_NOTIFICATIONS.ALLOW_NUMBER_PER_APPLICATION))) {
                displayNotification = true;
                notifierImageClass = "notifierImgMiniError";
                notifierClass = "notifierMiniError";
                template = TemplateErrorMini;
            }
            else if (options.type === CONST.SYSTEM_NOTIFICATIONS.ERROR_BLOCKING) {
                displayNotification = true;
                notifierImageClass = "notifierImgError";
                notifierClass = "notifierError";
                template = TemplateError;
            }
            else if (options.type === CONST.SYSTEM_NOTIFICATIONS.ERROR_GLOBAL) {
                // override the container to block all the application
                container = rootContainer;
                displayNotification = true;
                notifierImageClass = "notifierImgError";
                notifierClass = "notifierError";
                template = TemplateError;
            }
            else if (options.type === CONST.SYSTEM_NOTIFICATIONS.CONFIRM) {
                displayNotification = true;
                notifierImageClass = "notifierImgConfirm";
                notifierClass = "notifierConfirm";
                template = TemplateConfirm;
            }
            else if (options.type === CONST.SYSTEM_NOTIFICATIONS.CONFIRM_GLOBAL) {
                // override the container to block all the application
                container = rootContainer;
                displayNotification = true;
                notifierImageClass = "notifierImgConfirm";
                notifierClass = "notifierConfirm";
                template = TemplateConfirm;
            }
            else if (options.type === CONST.SYSTEM_NOTIFICATIONS.WARNING_NO_CLOSE) {
                displayNotification = true;
                notifierImageClass = "notifierImgWarning";
                notifierClass = "notifier";
                template = TemplateNoClose;
            }

            if (message) {
                switch (template) {
                    case TemplateConfirm:
                    case TemplateError:
                        contentMessageClass = "notifierMessageError";
                        break;
                    case TemplateErrorMini:
                        contentMessageClass = "notifierMessageMiniError";
                        break;
                    case TemplateInfo:
                        contentMessageClass = "notifierMessage";
                        break;
                    default:
                        contentMessageClass = "";
                }
            }

            if (!(container && displayNotification)) {
                return;
            }

            if (_isContentDisplayed(module, content)) {
                return;
            }

            var sanitizedMessage = HtmlSanitizerUtils.sanitizeHtml(message);
            if(sanitizedMessage.sanitized){
                logger.error("Notifier:SanitizeError", "Notifier::show", message);
                logger.graph({name: "UIComponents:Notifier:SanitizeError" });
                message = sanitizedMessage.cleanText;
            }

            var requestTop = _.isUndefined(options.top) || !_.isNumber(options.top) ? 0 : options.top;
            var instance = _createModuleInstance(module, content, requestTop);
            topPosition = instance.top;

            var notifierModel = new NotifierModel({
                module: module,
                type: options.type,
                textAction: textAction,
                textAdditionalButton: textAdditionalButton,
                textMiddleButton:    textMiddleButton,
                removePrimaryButton:   removePrimaryButton,
                removeMiddleButton:    removeMiddleButton,
                removeAditionalButton: removeAditionalButton,
                title: title,
                message: message,
                notifierImageClass: notifierImageClass,
                notifierClass: notifierClass,
                topPosition: topPosition,
                contentMessageClass: contentMessageClass,
                closeButtonText: closeButtonText
            });

            //TODO this is a patch for class name only compatibility. need to support id selector too for instance or element like body, etc...
            var notifierView = new NotifierView({
                template:template,
                model:notifierModel,
                container:container.substr(0, 1) === "." ? container : "." + container,
                callback:callback,
                middleCallback:middleCallback,
                cancelCallback:cancelCallback,
                vent:vent,
                timeToShow:timeToShow,
                contentView: contentView,
                instanceId: instance.id,
                persist: persist,
                disableClickToClose : options.disableClickToClose,
                pageToIgnoreDomEvents: pageToIgnoreDomEvents
            });

            notifierView.render();

            return notifierView;
        };

        return {
            showInfo:function (options) {
                var notification = show({
                    type:CONST.SYSTEM_NOTIFICATIONS.INFO,
                    module:getModule(),
                    content:options.content || options,
                    container: options.container,
                    top:options.top,
                    pageToIgnoreDomEvents: options.pageToIgnoreDomEvents
                });

                return {
                    close:function () {
                        if (notification){
                            notification.closeNotifier();
                        }
                    }
                };
            },
            showWarning: function(options) {
                var notification = show({
                    type: CONST.SYSTEM_NOTIFICATIONS.WARNING,
                    module: getModule(),
                    content:options.content || options,
                    container: options.container,
                    top:options.top,
                    timeToShow: options.timeToShow || DEFAULT_TIME_TO_SHOW,
                    pageToIgnoreDomEvents: options.pageToIgnoreDomEvents
                });

                return {
                    close:function () {
                        if (notification){
                            notification.closeNotifier();
                        }
                    }
                };
            },
            showWarningNoClose: function(options) {
                var notification = show({
                    type: CONST.SYSTEM_NOTIFICATIONS.WARNING_NO_CLOSE,
                    module: getModule(),
                    content:options.content || options,
                    container: options.container,
                    top:options.top,
                    timeToShow: options.timeToShow || DEFAULT_TIME_TO_SHOW,
                    persist: options.persist || false,
                    disableClickToClose: options.disableClickToClose || false
                });

                return {
                    close:function () {
                        if (notification){
                            notification.closeNotifier();
                        }
                    }
                };
            },
            showSuccess:function (options) {
                var notification = show({
                    type:CONST.SYSTEM_NOTIFICATIONS.SUCCESS,
                    module:getModule(),
                    content:options.content || options,
                    container: options.container,
                    top:options.top,
                    timeToShow: options.timeToShow,
                    pageToIgnoreDomEvents: options.pageToIgnoreDomEvents
                });

                return {
                    close:function () {
                        if (notification){
                            notification.closeNotifier();
                        }
                    }
                };
            },
            showMiniError: function(options) {
                var notification = show({
                    type: CONST.SYSTEM_NOTIFICATIONS.ERROR_MINI,
                    module: getModule(),
                    content: options.content,
                    objectAction: options.objectAction,
                    persist: true,
                    disableClickToClose: true,
                    top:ERROR_MINI_NOTIFIER_TOP });

                return {
                    close:function () {
                        if (notification){
                            notification.closeNotifier();
                        }
                    },
                    invokeAction:function () {
                        if (notification){
                            notification.invokeAction();
                        }
                    }
                };
            },
            showError:function (options) {
                var notification;

                // check if its an object
                if(_.isPlainObject(options)) {
                    if(_.isEmpty(options.title) || _.isEmpty(options.objectAction)){
                        notification = show({
                            type: CONST.SYSTEM_NOTIFICATIONS.ERROR,
                            module: getModule(),
                            content: options.content,
                            timeToShow:options.timeToShow,
                            container: options.container,
                            top:options.top,
                            pageToIgnoreDomEvents: options.pageToIgnoreDomEvents
                        });
                    }else{
                        notification = show({
                            type: CONST.SYSTEM_NOTIFICATIONS.ERROR_BLOCKING,
                            module: getModule(),
                            title: options.title,
                            content: options.content,
                            timeToShow:options.timeToShow,
                            objectAction: options.objectAction,
                            removePrimaryButton: options.removePrimaryButton,
                            removeAditionalButton:options.removeAditionalButton,
                            top:options.top,
                            pageToIgnoreDomEvents: options.pageToIgnoreDomEvents
                        });
                    }
                } else{
                    notification = show({
                        type: CONST.SYSTEM_NOTIFICATIONS.ERROR,
                        module: getModule(),
                        content: options,
                        timeToShow:options.timeToShow,
                        top:options.top,
                        pageToIgnoreDomEvents: options.pageToIgnoreDomEvents
                    });
                }

                return {
                    close:function () {
                        if (notification){
                            notification.closeNotifier();
                        }
                    },
                    invokeAction:function () {
                        if (notification){
                            notification.invokeAction();
                        }
                    }
                };
            },
            showGlobalError:function (options) {
                var notification = show({
                    type:CONST.SYSTEM_NOTIFICATIONS.ERROR_GLOBAL,
                    title:options.title,
                    content:options.content,
                    objectAction: options.objectAction,
                    removePrimaryButton: options.removePrimaryButton,
                    removeAditionalButton:options.removeAditionalButton,
                    pageToIgnoreDomEvents: options.pageToIgnoreDomEvents
                });

                return {
                    close:function () {
                        if (notification){
                            notification.closeNotifier();
                        }
                    },
                    invokeAction:function () {
                        if (notification){
                            notification.invokeAction();
                        }
                    }
                };
            },
            showConfirm:function (options) {
                var notification = show({
                    type:CONST.SYSTEM_NOTIFICATIONS.CONFIRM,
                    module:getModule(),
                    title:options.title,
                    content: options.content,
                    objectAction:         options.objectAction,
                    removePrimaryButton:  options.removePrimaryButton,
                    removeMiddleButton:   options.removeMiddleButton,
                    removeAditionalButton:options.removeAditionalButton,
                    pageToIgnoreDomEvents: options.pageToIgnoreDomEvents
                });

                return {
                    close:function () {
                        if (notification){
                            notification.closeNotifier();
                        }
                    },
                    invokeAction:function () {
                        if (notification){
                            notification.invokeAction();
                        }
                    }
                };
            },
            showGlobalConfirm:function (options) {
                var notification = show({
                    type:CONST.SYSTEM_NOTIFICATIONS.CONFIRM_GLOBAL,
                    title:options.title,
                    content:options.content,
                    objectAction: options.objectAction,
                    removePrimaryButton: options.removePrimaryButton,
                    removeAditionalButton:options.removeAditionalButton,
                    pageToIgnoreDomEvents: options.pageToIgnoreDomEvents
                });

                return {
                    close:function () {
                        if (notification){
                            notification.closeNotifier();
                        }
                    },
                    invokeAction:function () {
                        if (notification){
                            notification.invokeAction();
                        }
                    }
                };
            }
        };

    };
    return Notifier;
});
